export default __webpack_public_path__ + "static/media/SampleBatch.d4d43c16.xlsx";